<div class="error-message" *ngIf="message">
    <app-error-icon></app-error-icon>
    <span> {{ message }}</span>
</div>
